import { TaskModel } from './models/task-model';
import { TaskModelImpl } from './models/impls/task-model';
import { TaskService } from './services/task-service';
import { TaskServiceImpl } from './services/impls/task-service';
import { TaskRecentService } from './services/task-recent-service';
import { TaskRecentServiceImpl } from './services/impls/task-recent-service';
import { TaskStatusSyncService } from './services/task-status-sync-service';
import { TaskStatusSyncServiceImpl } from './services/impls/task-status-sync-service';
import { GetTaskListRep, GetTaskStatusRep } from './services/task-repository';
import { TaskQueueService } from './services/task-queue-service';
import { TaskQueueServiceImpl } from './services/impls/task-queue-service';
import { GetTaskListRepImpl } from './repositories/impls/get-task-list-repository';
import { GetTaskStatusRepImpl } from './repositories/impls/get-task-status-repository';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { TaskApiImpl } from './apis/impls/task-api';
import { TaskApi } from './apis/task-api';
import { TaskNameServiceImpl } from '@/services/task-name-service/impls/task-name-service';
import { TaskNameService } from '@/services/task-name-service/task-name-service';
import { TaskExportServiceImpl } from './services/impls/task-export-service';
import { TaskExportService } from './services/task-export-service';
import { CommandContribution } from '@patsnap/tahiti-core';
import { TaskExportContribution } from './services/task-export-contribution';
import { OpenNewTaskImpl } from '@/services/open-new-task/impls/open-new-task';
import { OpenNewTask } from '@/services/open-new-task/open-new-task';
import { CurrentTaskInputModel } from './models/current-task-input-model';
import { CurrentTaskInputModelImpl } from './models/impls/current-task-input-model';

export const taskModule = (bind: interfaces.Bind) => {
    bind(TaskModel).to(TaskModelImpl);
    bind(CurrentTaskInputModel).to(CurrentTaskInputModelImpl);
    bind(TaskService).to(TaskServiceImpl);
    bind(TaskRecentService).to(TaskRecentServiceImpl);
    bind(TaskStatusSyncService).to(TaskStatusSyncServiceImpl);
    bind(TaskQueueService).to(TaskQueueServiceImpl);
    bind(GetTaskListRep).to(GetTaskListRepImpl);
    bind(GetTaskStatusRep).to(GetTaskStatusRepImpl);
    bind(TaskApi).to(TaskApiImpl);
    bind(TaskNameService).to(TaskNameServiceImpl);
    bind(TaskExportService).to(TaskExportServiceImpl);
    bind(CommandContribution).to(TaskExportContribution);
    bind(OpenNewTask).to(OpenNewTaskImpl);
};
